import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const services = [
  {
    icon: (
      <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
        <circle cx="32" cy="20" r="6" fill="currentColor"/>
        <circle cx="26" cy="12" r="3" fill="currentColor"/>
        <circle cx="38" cy="12" r="3" fill="currentColor"/>
        <path d="M28 30 L24 58 C24 60 26 62 32 62 C38 62 40 60 40 58 L36 30 Z" fill="currentColor"/>
      </svg>
    ),
    title: 'Rock and Roll Nights',
    description: 'Rolling, Rocking, and Bowling Fun! Experience our exciting glow bowling with music, lights, and an electrifying atmosphere every weekend.',
    schedule: [
      { day: 'Fri', time: '3.00 pm - 10.00 pm' },
      { day: 'Sat', time: '12.00 pm - 10.00 pm' },
    ],
    btnText: 'Call to Book',
    link: 'tel:+15704217680',
    isExternal: true,
  },
  {
    icon: (
      <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
        <rect x="12" y="28" width="40" height="8" rx="4" fill="currentColor"/>
        <rect x="16" y="20" width="32" height="10" rx="3" fill="currentColor"/>
        <circle cx="24" cy="14" r="4" fill="currentColor"/>
        <circle cx="40" cy="14" r="4" fill="currentColor"/>
        <rect x="20" y="36" width="24" height="6" rx="2" fill="currentColor"/>
        <rect x="26" y="42" width="12" height="12" rx="2" fill="currentColor"/>
      </svg>
    ),
    title: 'Delicious Food',
    description: 'Satisfy Your Cravings with our full-service snack bar featuring burgers, pizza, wings, and refreshing beverages for the whole family.',
    btnText: 'Know More',
    link: '#about',
    isExternal: true,
  },
  {
    icon: (
      <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
        <rect x="8" y="16" width="48" height="32" rx="4" fill="currentColor"/>
        <rect x="12" y="20" width="40" height="24" rx="2" fill="none" stroke="currentColor" strokeWidth="2"/>
        <path d="M20 52 L16 58 L48 58 L44 52" fill="currentColor"/>
        <circle cx="32" cy="32" r="6" fill="none" stroke="currentColor" strokeWidth="2"/>
        <path d="M32 26 L32 22 M32 42 L32 38 M26 32 L22 32 M42 32 L38 32" stroke="currentColor" strokeWidth="2"/>
      </svg>
    ),
    title: 'Corporate Events',
    description: 'Impress Your Team with our customizable corporate event packages. Team building, celebrations, and private lane reservations available.',
    btnText: 'Know More!',
    link: '/parties-events',
    isExternal: false,
  },
];

function FlipCard({ service }) {
  const [flipped, setFlipped] = useState(false);
  return (
    <div
      className={`flip-card ${flipped ? 'flipped' : ''}`}
      onClick={() => setFlipped(!flipped)}
    >
      <div className="flip-card-inner">
        <div className="flip-card-front">
                    <h3>{service.title}</h3>
                    <p>{service.description}</p>
                    <span className="flip-hint">Tap to see schedule</span>
                  </div>
                  <div className="flip-card-back">
                    <h3>Rock & Bowl Schedule</h3>
                    <div className="service-schedule">
                      {service.schedule.map((s, i) => (
                        <div className="schedule-row" key={i}>
                          <span className="schedule-day">{s.day}</span>
                          <span className="schedule-time">{s.time}</span>
                        </div>
                      ))}
                    </div>
                    <a href={service.link} className="btn" onClick={(e) => e.stopPropagation()}>{service.btnText}</a>
                  </div>
                </div>
              </div>
  );
}

function ServiceCards() {
  return (
    <section className="service-cards">
      <div className="container">
        {services.map((service, index) => (
          <div className="service-card" key={index}>
            <div className="service-card-icon">
              {service.icon}
            </div>
            {service.schedule ? (
              <FlipCard service={service} />
            ) : (
              <>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                {service.isExternal ? (
                  <a href={service.link} className="btn">{service.btnText}</a>
                ) : (
                  <Link to={service.link} className="btn">{service.btnText}</Link>
                )}
              </>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}

export default ServiceCards;
